function createTextStyle(defaults) {
  return Object.assign({
    family: 'Arial, Helvetica, sans-serif',
    size: '14px',
    color: '#FFFFFF',
    align: 'center',
    weight: '600',
    style: 'initial',
    stroke: 'none',
  }, defaults || {});
}

function createInstagramFeedConfig() {
  return {
    name: 'InstagramFeed',
    width: '900px',
    height: '800px',
    maxWidth: '900px',
    minHeight: '200px',
    feedHeaderHeight: '80px',
    postHeight: '180px',
    zIndex: 'auto',
    rotation: '0deg',
    border: '0 none #000000',
    boxShadow: '0 0 0 0 transparent',
    borderRadius: '0 0 0 0',
    backgroundColor: '#FFFFFF',
    backgroundImage: 'none',
    backgroundPosition: 'center',
    backgroundOrigin: 'border-box',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundAttachment: 'scroll',
    paddingTop: '20px',
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingBottom: '20px',
    showDesktop: true,
    showMobile: true,
    hideDesktopOrder: 0,
    hideMobileOrder: 0,
    tag: '',
    showHeader: true,
    headerType: 'header1',
    feedLayout: 'grid',
    sliderVisibleCount: 4,
    postOrder: 'newest',
    autoplayVideos: true,
    showMediaIcon: true,
    hoverEffectsEnabled: true,
    showInstagramLogo: true,
    showCaption: true,
    showBranding: true,
    openLinksInNewTab: true,
    showEngagement: true,
    showLikes: true,
    showComments: true,
    likesIconColor: '#FFFFFF',
    commentsIconColor: '#FFFFFF',
    engagementIconSize: 14,
    columns: 3,
    postsPerPage: 9,
    gap: 12,
    imageBorderRadius: 8,
    followButtonText: 'Follow on Instagram',
    followButtonBackground: '#0095F6',
    followButtonColor: '#FFFFFF',
    followButtonWidth: '160px',
    followButtonHeight: '40px',
    followButtonBorderRadius: '8px 8px 8px 8px',
    followButtonTextStyle: createTextStyle({
      size: '14px',
      color: '#FFFFFF',
      weight: '600',
    }),
    followButtonIcon: '',
    followButtonIconPosition: 'left',
    followButtonBackgroundImage: 'none',
    followButtonBackgroundPosition: 'center',
    followButtonBackgroundOrigin: 'border-box',
    followButtonBackgroundRepeat: 'no-repeat',
    followButtonBackgroundSize: 'cover',
    followButtonHoverEnabled: true,
    followButtonHoverBackground: '#1877F2',
    followButtonHoverColor: '#FFFFFF',
    showLoadMore: true,
    loadMoreText: 'Load More Posts',
    loadMoreBackground: '#EFEFEF',
    loadMoreColor: '#262626',
    loadMoreButtonWidth: '420px',
    loadMoreButtonHeight: '44px',
    loadMoreBorderRadius: '8px 8px 8px 8px',
    loadMoreTextStyle: createTextStyle({
      size: '14px',
      color: '#262626',
      weight: '600',
    }),
    loadMoreIcon: '',
    loadMoreIconPosition: 'left',
    loadMoreBackgroundImage: 'none',
    loadMoreBackgroundPosition: 'center',
    loadMoreBackgroundOrigin: 'border-box',
    loadMoreBackgroundRepeat: 'no-repeat',
    loadMoreBackgroundSize: 'cover',
    loadMoreHoverEnabled: false,
    loadMoreHoverBackground: '#E0E0E0',
    loadMoreHoverColor: '#262626',
    filterIncludeHashtags: [],
    filterExcludeHashtags: [],
    customPostOrder: [],
    hiddenPostIds: [],
    animation: {
      in: {
        action: 'time',
        time: 0,
        scroll: 0,
        effect: 'none',
        speed: 'slow',
        infinite: false,
      },
      out: {
        action: 'time',
        time: 0,
        scroll: 0,
        effect: 'none',
        delay: '1',
        speed: '1',
        infinite: false,
      },
    },
  };
}

export default {
  data() {
    const base = createInstagramFeedConfig();

    return {
      props: Object.assign({}, base),
      internal_config: Object.assign({}, base),
    };
  },
};
